import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Box, Button, Card, TextField } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../store/loader';
import Loader from '../../components/UI/Loader/loader';
import { ErrorObject } from '../../types/types';
import styles from './Login.module.css';
import { useAuthService } from '../../hooks';
import { Validator } from '../../../utils/validator';

const Login = () => {
  const AuthService = useAuthService();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [alert, setAlert] = useState(false);

  const [emailError, setEmailError] = useState<ErrorObject>({
    hasError: false,
    message: ''
  });
  const [passwordError, setPasswordError] = useState<ErrorObject>({
    hasError: false,
    message: ''
  });

  const isLoading = (state: boolean) => {
    dispatch(loaderActions.setLoading(state));
  };

  const isValid = () => {
    const emailErrorData = Validator(email, ['required']);
    setEmailError(emailErrorData);
    const passwordErrorData = Validator(password, ['required']);
    setPasswordError(passwordErrorData);
    return !emailErrorData.hasError && !passwordErrorData.hasError;
  };

  const loginHandler = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!isValid()) return;

    isLoading(true);
    AuthService.loginInWithEmailAndPassword(email, password)
      .then(() => navigate('/'))
      .catch((e) => {
        console.log(e);
        setAlert(true);
      })
      .finally(() => isLoading(false));
  };

  const goToRegister = () => {
    navigate('/register');
  };

  return (
    <Box className={styles.container}>
      <form onSubmit={loginHandler} autoComplete='off'>
        <Card className={styles.card}>
          <TextField
            id='email'
            label='Email'
            variant='outlined'
            margin='normal'
            color='primary'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={emailError.hasError}
            helperText={emailError.message}
          />
          <TextField
            id='password'
            type='password'
            label='Password'
            variant='outlined'
            margin='normal'
            color='primary'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={passwordError.hasError}
            helperText={passwordError.message}
          />
          <Button type='submit' variant='contained' color='primary' sx={{ marginTop: '10px' }}>
            Login
          </Button>
          <Box className={styles.divider} sx={{ marginY: '4px' }}>
            <span className={styles.dividerLabel}>or</span>
          </Box>
          <Button type='button' variant='outlined' color='primary' onClick={goToRegister}>
            Register
          </Button>
        </Card>
      </form>
      <Snackbar
        open={alert}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        autoHideDuration={6000}
        onClose={() => setAlert(false)}
      >
        <Alert onClose={() => setAlert(false)} severity='error' sx={{ width: '100%' }}>
          Nombre de usuario o contraseña incorrecta
        </Alert>
      </Snackbar>
      <Loader />
    </Box>
  );
};

export default Login;
